<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="!loaded ? '' : (('Messages With' | translate) + ' ' + (proxyUser?.first_name | translate) + ' ' + (proxyUser?.last_name | translate))"
      [canGoBack]="true"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-card>
        <form [formGroup]="messageForm">
          <ion-row>
            <tidy-select
              class="select-custom-input"
              [label]="assignLabel"
              [items]="assignList"
              (optionChange)="onSelectAssign($event)"
              [form]="messageForm.get('assignedTo')"
              formControlName="assignedTo"
              [icon]="'assets/svg/person.svg'" />
          </ion-row>
          <tidy-row class="extra-bottom-padding extra-top-padding" [alignLastItemRight]="true">
            <tidy-initials-icon
              [fullName]="proxyUser?.first_name + ' ' + proxyUser?.last_name" />
            <tidy-text
              [header]="proxyUser?.first_name + ' ' + proxyUser?.last_name"
              [translate]="false" />
            <tidy-text [body]="'Call'" class="link" (action)="callPro()" />
          </tidy-row>
          <tidy-row class="field-top-padding extra-bottom-padding">
            <tidy-textarea
              [label]="'Send Message'"
              formControlName="message"
              [form]="messageForm.controls.message"
              [submitted]="submitted"
              [errorMessage]="'Please enter a message to send.'"
              [rightIconAction]="boundSendMessage"
              [leftIconAction]="boundSendAttachment"
              [icon]="'assets/svg/chatbubble.svg'" />
          </tidy-row>
          @if (messages?.length == 0) {
            <tidy-row [align]="'center'">
              <tidy-text [helper]="'No Messages'" />
            </tidy-row>
          }
          @for (message of messages; track message; let last = $last) {
            <message [message]="message" [last]="last" />
          }
        </form>
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ng-container *ngTemplateOutlet="content" />
}